@if (pages$ | async; as _pages) {
    <div class="side-nav">
        <div [ngClass]="{ 'slide-hide': openChildNav !== null }" class="side-nav__wrapper">
            <div class="site-logo">
                <core-brand-logo category="SIDE-NAV" additionalClasses="mx-auto"></core-brand-logo>
            </div>
            @if (searchEnabled) {
                <core-search-form [autoFocus]="false" class="core-search-form--sidenav"></core-search-form>
            }
            <button
                (click)="hamburger = !hamburger; menuStateCheck(!hamburger)"
                [core-analytics]="{ action: 'Toggle menu', category: 'SIDE-NAV' }"
                [ngClass]="{ 'is-active': hamburger }"
                aria-label="Hamburger menu"
                class="hamburger hamburger--squeeze"
                type="button">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
            <!-- Not adding to DOM if we're showing the responsive menu -->
            @if (!isMobileNav) {
                <nav aria-label="Main navigation" class="side-nav__menu">
                    <ul class="side-nav__menu-list">
                        @for (page of $any(_pages | orderBy: ['displayOrder']); track trackByFn($index, page)) {
                            @if (showInMenu(page, 'no-child')) {
                                <li
                                    [ngClass]="{ 'nav-item--posts': isDemoModeAndPostsLink(page) }"
                                    class="side-nav__menu-item">
                                    @if (page.children.length === 0) {
                                        <a
                                            [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                                            [ngClass]="{ active: isCurrentPage(page) }"
                                            [routerLink]="
                                                page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url
                                            "
                                            class="side-nav__menu-link">
                                            {{ page.name }}
                                        </a>
                                    }
                                    @if (page.children.length > 0) {
                                        <a
                                            (click)="childNav(page)"
                                            [core-analytics]="{
                                                action: 'Toggle ' + page.name,
                                                category: 'SIDE-NAV',
                                            }"
                                            class="side-nav__menu-link side-nav__menu-link-has-children"
                                            href="javascript:void(0);">
                                            {{ page.name }}
                                        </a>
                                    }
                                </li>
                            }
                            <!-- ** REMOVE <li> FOR CLIENT BUILD **
Split out <li> for 'posts' demo toggle purposes only. This can be removed for a client build -->
                            @if (isDemoMode && page.url === 'articles' && postsEnabled) {
                                <li class="side-nav__menu-item">
                                    @if (page.children.length === 0) {
                                        <a
                                            (click)="childNav(page.url)"
                                            [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                                            [ngClass]="{ active: isCurrentPage(page) }"
                                            [routerLink]="
                                                page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url
                                            "
                                            aria-current="page"
                                            class="side-nav__menu-link"
                                            href="javascript:void(0)"
                                            id="{{ page.url }}">
                                            {{ page.name }}
                                        </a>
                                    }
                                </li>
                            }
                        }
                    </ul>
                </nav>
            }
            <core-side-nav-footer></core-side-nav-footer>
        </div>
        @if (openChildNav) {
            <div [ngClass]="{ active: !!openChildNav }" class="side-nav__children">
                @if (openChildNav.name) {
                    <h3 class="side-nav__children-heading">
                        <a
                            (click)="resetChildNav()"
                            [core-analytics]="{ action: 'Back', category: 'SIDE-NAV' }"
                            class="side-nav__children-back-link"
                            href="javascript:void(0)">
                            <span></span>
                            {{ 'Back' | translate }}
                        </a>
                    </h3>
                }
                <ul class="side-nav__child-menu-list">
                    @for (
                        page of $any(openChildNav.children || [] | orderBy: ['displayOrder', 'name']);
                        track trackByFn($index, page)
                    ) {
                        @if (
                            page.meta && (page.meta['showInMenu'] === 'true' || page.meta['showInMenu'] === "'true'")
                        ) {
                            <li class="side-nav__child-menu-item">
                                <a
                                    [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                                    [ngClass]="{ active: isCurrentPage(page) }"
                                    [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                                    class="side-nav__child-menu-link">
                                    {{ page.name }}
                                </a>
                            </li>
                        }
                    }
                </ul>
            </div>
        }
        <!-- Not adding to DOM if we're showing the desktop sidenav menu -->
        @if (isMobileNav) {
            <div [ngClass]="{ 'mobile-nav--active': hamburger }" class="mobile-nav">
                <div class="mobile-nav__wrapper">
                    @if (searchEnabled) {
                        <core-search (closeSidenavHamburgerNav)="hamburger = !hamburger"></core-search>
                    }
                    <div [ngClass]="{ active: openChildNav !== null }" class="side-nav__wrapper">
                        <!-- If search is needed, uncomment this out and ensure /search page in Core is not DRAFT -->
                        <!-- <core-search (closeSidenavHamburgerNav)="closeResponsiveMenuOnSearch($event)"></core-search> -->
                        <nav aria-label="Mobile navigation" class="side-nav__menu">
                            <ul class="side-nav__menu-list">
                                @for (page of $any(_pages | orderBy: ['displayOrder']); track trackByFn($index, page)) {
                                    @if (
                                        page.meta.showInMenu === 'true' ||
                                        page.meta.showInMenu === "'true'" ||
                                        page.meta.showInMenu === true ||
                                        page.name === 'home'
                                    ) {
                                        <li class="side-nav__menu-item">
                                            @if (page.children.length === 0) {
                                                <a
                                                    (click)="hamburger = !hamburger"
                                                    [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                                                    [ngClass]="{ active: isCurrentPage(page) }"
                                                    [routerLink]="
                                                        page.url === 'default'
                                                            ? '/'
                                                            : page.meta.redirect || '/' + page.url
                                                    "
                                                    class="side-nav__menu-link">
                                                    {{ page.name }}
                                                </a>
                                            }
                                            @if (page.children.length > 0) {
                                                <a
                                                    (click)="childNav(page)"
                                                    [core-analytics]="{
                                                        action: 'Toggle ' + page.name,
                                                        category: 'SIDE-NAV',
                                                    }"
                                                    class="side-nav__menu-link side-nav__menu-link-has-children"
                                                    href="javascript:void(0);">
                                                    {{ page.name }}
                                                </a>
                                            }
                                        </li>
                                    }
                                }
                            </ul>
                        </nav>
                        <core-side-nav-footer></core-side-nav-footer>
                    </div>

                    @if (openChildNav) {
                        <div
                            [ngClass]="{
                                active: !!openChildNav,
                                'search-on': searchEnabled,
                            }"
                            class="side-nav__children">
                            @if (openChildNav.name) {
                                <h3 class="side-nav__children-heading">
                                    <a
                                        (click)="resetChildNav()"
                                        [core-analytics]="{ action: 'Back', category: 'SIDE-NAV' }"
                                        class="side-nav__children-back-link"
                                        href="javascript:void(0)">
                                        <span></span>
                                        {{ 'Back' | translate }}
                                    </a>
                                </h3>
                            }
                            <ul class="side-nav__children-list">
                                @for (page of $any(openChildNav.children || []); track trackByFn($index, page)) {
                                    @if (
                                        page.meta &&
                                        (page.meta['showInMenu'] === 'true' || page.meta['showInMenu'] === "'true'")
                                    ) {
                                        <li class="side-nav__children-item">
                                            <a
                                                (click)="resetChildNav(); hamburger = !hamburger"
                                                [core-analytics]="{ action: page.url, category: 'SIDE-NAV' }"
                                                [routerLink]="
                                                    page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url
                                                "
                                                class="side-nav__children-link">
                                                {{ page.name }}
                                            </a>
                                        </li>
                                    }
                                }
                            </ul>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}
